// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lVjcn","lightbox":"kCcIo","icon-close":"_1LJtn"};